<script lang="ts">
	import { format } from 'svelte-i18n';
	import { Text } from '@Shelly/shelly-design-system/index';

	/** Whether the recording indicator is visible */
	export let visible: boolean = true;
	/** Optional recording duration to display (e.g., "00:01") */
	export let duration: string = '';
</script>

{#if visible}
	<div
		class="recording-indicator"
		role="status"
		aria-label={$format('camera_recording_in_progress', { default: 'Recording in progress' })}
	>
		<div class="live-indicator" aria-hidden="true">
			<i class="fas fa-circle"></i>
		</div>
		<Text styleType="label-extra-small" class="recording-text">
			{$format('camera_recording_short', { default: 'REC' })}{#if duration}&nbsp;{duration}{/if}
		</Text>
	</div>
{/if}

<style>
	.recording-indicator {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		gap: var(--spacing-xs, 4px);
		height: 24px;
		padding: 6px 8px 6px 6px;
		background-color: var(--color-danger);
		border-radius: var(--spacing-s-plus, 12px);
	}

	.live-indicator {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 14px;
		height: 14px;
		color: var(--color-base);
		font-size: 11px;
		animation: blink 1s ease-in-out infinite;
	}

	.live-indicator i {
		font-size: 8px;
	}

	@keyframes blink {
		0%,
		100% {
			opacity: 1;
		}
		50% {
			opacity: 0.3;
		}
	}

	.recording-indicator :global(.recording-text) {
		color: var(--color-base);
		font-size: 10px;
		font-weight: 500;
		line-height: 11px;
		text-transform: uppercase;
		letter-spacing: 0.3px;
	}
</style>
